import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';

import { provideBaasInitialized } from '@lvflanders/bar-ng';

import { DidoCoreOptions } from '../models/dido-core-options.model';
import { DidoCoreInitializedHook } from './dido-core-initialized.hook';
import { DidoCoreStateService } from './dido-core-state.service';

export function provideDidoCore(config: DidoCoreOptions = {}) {
    const providers: Array<Provider | EnvironmentProviders> = [
        DidoCoreStateService,
        provideBaasInitialized(DidoCoreInitializedHook),
        {
            provide: DidoCoreOptions,
            useValue: config
        }
    ];
    return makeEnvironmentProviders(providers);
}
